function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 511.999 511.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M300.982 211.018c-11.455-11.455-24.819-19.303-39.244-24.396-22.486-8.06-47.519-8.06-70.005 0-14.425 5.092-27.789 12.941-39.244 24.396L30.706 332.802c-40.941 40.941-40.941 107.551 0 148.492s107.551 40.941 148.492 0l121.783-121.783c41.154-41.154 39.669-108.824.001-148.493m-164.21 227.85c-17.607 17.607-46.032 17.607-63.64 0-17.607-17.607-17.607-46.032 0-63.64l121.783-121.783c17.607-17.607 46.032-17.607 63.64 0s17.607 46.032 0 63.64z",
    style: {
      fill: "#ff7816"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.982 359.511 179.198 481.294c-40.941 40.941-107.551 40.941-148.492 0l42.426-42.426c17.607 17.607 46.032 17.607 63.64 0l121.783-121.783c17.607-17.607 17.607-46.032 0-63.64l42.426-42.426c39.669 39.668 41.154 107.338.001 148.492",
    style: {
      fill: "#ff4b00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.294 179.198 364.621 295.871c-11.455 11.455-24.819 19.303-39.244 24.396-22.486 8.06-47.519 8.06-70.005 0-14.425-5.092-27.789-12.941-39.244-24.396s-19.303-24.819-24.396-39.244l3.182-3.183c17.607-17.607 46.032-17.607 63.64 0s46.032 17.607 63.64 0l116.673-116.673c17.607-17.607 17.607-46.032 0-63.64-17.607-17.607-46.032-17.607-63.64 0l-113.49 113.49c-22.486-8.06-47.519-8.06-70.005 0 5.092-14.425 12.941-27.789 24.396-39.244L332.802 30.706c40.941-40.941 107.551-40.941 148.492 0s40.941 107.551 0 148.492",
    style: {
      fill: "#76e2f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.294 179.198 364.621 295.871c-11.455 11.455-24.819 19.303-39.244 24.396-22.486 8.06-47.519 8.06-70.005 0-14.425-5.092-27.789-12.941-39.244-24.396l42.426-42.426c17.607 17.607 46.032 17.607 63.64 0l116.673-116.673c17.607-17.607 17.607-46.032 0-63.64l42.426-42.426c40.942 40.941 40.942 107.551.001 148.492",
    style: {
      fill: "#25d9f8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.d4ef016d85e490d94707e7707eaf2094.svg";
export { ForwardRef as ReactComponent };